export const formatToIndianCurrency = (value) => {
  return value
    .toLocaleString("en-IN", {
      maximumFractionDigits: 0,
      style: "currency",
      currency: "INR",
    })
    .replace("₹", "₹ ");
};
